import { Link } from 'react-router-dom';
import { gameCategories } from '@/mocks/homeData';

export default function GameCategorySection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            丰富<strong className="text-primary-500">游戏种类</strong>
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            六大品类，3000+款精品游戏，满足您的所有娱乐需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {gameCategories.map((cat) => (
            <Link
              key={cat.id}
              to="/category"
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <div className="flex items-center gap-2 text-background-50">
                    <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500/90">
                      <i className={`${cat.icon} text-sm`}></i>
                    </div>
                    <h3 className="font-heading text-lg font-semibold">{cat.name}</h3>
                  </div>
                </div>
              </div>
              <div className="p-5">
                <p className="text-sm text-foreground-600">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border border-primary-300 text-primary-600 font-medium text-sm hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            查看全部游戏
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}